import React, { useMemo } from 'react';
import { hasMainEntities } from '../../../TreeMenu/utils';
import { sectionPrefix } from '../../../NavigationMenu/utils';
import style from '../../LibraryView.scss';
import { CodeExamples } from '../../../CodeExamples';
import { MainEntityDetails } from './MainEntityDetails';
import { IntersectionSubscriber } from '../../../SectionIntersectionDetection/IntersectionSubscriber';
import { isMainEntity } from '../../../../../utils/flattenTree/utils/extractors';

interface MainEntityProps {
  node: any;
  prefix: string;
}

export function MainEntity({ node, prefix }: MainEntityProps) {
  const JSLayoutType = node?.data?.layoutType === 'JS';
  const mainEntity = useMemo(() => {
    const isNodeHasMainEntities = hasMainEntities(node);
    if (isNodeHasMainEntities) {
      return (node?.data?.messages || []).find(isMainEntity);
    }
  }, [node]);

  if (mainEntity) {
    const id = sectionPrefix(prefix, mainEntity.urlFormat);
    return (
      <section
        key={`__section_${mainEntity.name}`}
        className={style.sectionWrapper}
      >
        <IntersectionSubscriber
          tagName="tag"
          className={style.intersectionSubscriber}
          id={id}
        />
        <MainEntityDetails
          id={id}
          node={node}
          message={mainEntity}
          prefix={prefix}
        />
        <CodeExamples
          data={mainEntity}
          prefix={prefix}
          JSLayoutType={JSLayoutType}
        />
      </section>
    );
  }
  return null;
}
